import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewMilestone page components
// import FormField from "../FormField";
import FormField from "components/Form/FormField";
import { RequestService } from "services/RequestService";
import Autocomplete from "@mui/material/Autocomplete";
import { useEffect, useState, useRef } from "react";

function EditForm({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { name, description, startDate, endDate, progress, Status, projectId } = formField;
  const {
    name: nameV,
    description: descriptionV,
    startDate: startDateV,
    endDate: endDateV,
    progress: progressV,
    Status: StatusV,
    projectId: projectIdV,
  } = values;
  const [milestoneStatus, setMilestoneStatus] = useState([]);
  const isOptionEqualToValue = (option, value) => option.id === value.id;
  // read project id from url
  const urlParams = new URLSearchParams(window.location.search);
  const projectIdParam = urlParams.get("projectId");
  useEffect(() => {
    setFieldValue("projectId", projectIdParam);
    let options = [];
    RequestService.get("Milestone/MilstoneStatusList").then((res) => {
      if (res && res.data && res.status === 200 && res.data.data != null) {
        let js = res.data.data;
        Object.entries(js).forEach(([key, value]) => {
          options.push({ label: key, value: value });
        });
      }
    });
    setMilestoneStatus(options);
  }, []);
  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">معلومات المرحلة</MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
              success={nameV.length > 0 && !errors.name}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <FormField
              type={description.type}
              label={description.label}
              name={description.name}
              value={descriptionV}
              placeholder={description.placeholder}
              error={errors.description && touched.description}
              success={!errors.description}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <FormField
              type={startDate.type}
              label={startDate.label}
              name={startDate.name}
              value={startDateV}
              placeholder={startDate.placeholder}
              error={errors.startDate && touched.startDate}
              success={startDateV.length > 0 && !errors.startDate}
              // style={{ backgroundColor: "yellow" }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={endDate.type}
              label={endDate.label}
              name={endDate.name}
              value={endDateV}
              placeholder={endDate.placeholder}
              error={errors.endDate && touched.endDate}
              success={endDateV.length > 0 && !errors.endDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={progress.type}
              label={progress.label}
              name={progress.name}
              value={progressV}
              placeholder={progress.placeholder}
              error={errors.progress && touched.progress}
              success={progressV >= 0 && !errors.progress}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={milestoneStatus}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="standard"
                  label={Status.label}
                  value={Status}
                  name={Status.name}
                  placeholder={Status.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("Status", v.value);
              }}
            />
          </Grid>

          {/* <Grid item xs={12}>
            <FormField
              type={projectId.type}
              label={projectId.label}
              name={projectId.name}
              value={projectIdV}
              placeholder={projectId.placeholder}
              error={errors.projectId && touched.projectId}
              success={projectIdV > 0 && !errors.projectId}
            />
          </Grid> */}
        </Grid>
      </MDBox>
    </MDBox>
  );
}

EditForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default EditForm;
